function moveDeliveryPromise() {
    const interval = setInterval(() => {
        const deliveryPromise = document.querySelector('delivery-promise-wc');
        const qtyWithBuy = document.querySelector('.qty_with_buy');
       

        if (!deliveryPromise) return;

        if (qtyWithBuy) {
            qtyWithBuy.insertAdjacentElement('afterend', deliveryPromise);
            clearInterval(interval);
            console.log('Delivery Promise moved');
        } else{
            console.log("not moved");
        }
    }, 500);

    // Stop checking after 30s
    setTimeout(() => clearInterval(interval), 30000);
}

document.addEventListener('DOMContentLoaded', moveDeliveryPromise);

$(document).ready(function () {

    // Open modal on click
    $(document).on('click', 'body.page-rewards-new .reward-point-btn', function(e){
        e.preventDefault();
        $('#lion-modal-overlay').fadeIn();
    });

    // Close on button click
    $('#lion-modal-close').on('click', function(){
        $('#lion-modal-overlay').fadeOut();
    });

    // Close on outside click
    $('#lion-modal-overlay').on('click', function(e){
        if ($(e.target).is('#lion-modal-overlay')) {
        $(this).fadeOut();
        }
    });

    if (sessionStorage.getItem("brandsredirect")) {
        var target = $("#shopify-section-template--18095346745409__shop_brands_r9FjUN");
        if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 1200);
        }
        sessionStorage.removeItem("brandsredirect");
    }
    
    $(".faq-collection-m .faq-question").on("click", function () {
        var faqItem = $(this).closest(".faq-item");
        var answer = faqItem.find(".faq-answer");
        if (faqItem.hasClass("active")) {
            faqItem.removeClass("active");
            answer.slideUp();
        } else {
            $(".faq-collection-m .faq-item").removeClass("active");
            $(".faq-collection-m .faq-answer").slideUp();
            faqItem.addClass("active");
            answer.slideDown();
        }
    });
    $(".auto-sliding-announcements .marquee-announcements").slick({
        speed: 15000,
        autoplay: !0,
        autoplaySpeed: 0,
        cssEase: "linear",
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: !0,
        arrows: !1,
        buttons: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        responsive: [{ breakpoint: 575, settings: { slidesToShow: 2, slidesToScroll: 1 } }],
    });
    $(".carousel-slick-items-slider").slick({
        dots: !1,
        arrows: !1,
        infinite: !0,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: !0,
        pauseOnHover: !1,
        autoplaySpeed: 1200,
        responsive: [
            { breakpoint: 990, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    });
    $(".weight-loss-plans-slider").slick({
        dots: !1,
        arrows: !0,
        infinite: !0,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: !0,
        autoplaySpeed: 2000,
        responsive: [{ breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: !1 } }],
    });
    $(".meal-plan-bundle-list").slick({
        dots: !1,
        arrows: !0,
        infinite: !0,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: !0,
        autoplaySpeed: 2000,
        responsive: [{ breakpoint: 767, settings: { slidesToShow: 1, arrows: !1 } }],
    });
    $("a#HeaderMenu-brands").on("click", function (e) {
        e.preventDefault();
        var target = $("#shopify-section-template--18095346745409__shop_brands_r9FjUN");
        if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 1200);
        } else {
            sessionStorage.setItem("brandsredirect", !0);
            window.location.href = "/";
        }
    });
    $(".scroll-to-meal").on("click", function (e) {
        e.preventDefault();
        var index = $(this).data("index");
        var target = $("#meal_index_" + index);
        if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 1200);
        }
    });
    $(".scroll-to-block").on("click", function (e) {
        e.preventDefault();
        var index = $(this).data("index");
        var target = $("#block_index_" + index);
        if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 1200);
        }
    });
    $(".scroll_btn").on("click", function (e) {
        e.preventDefault();
        var currentSection = $(this).closest(".shopify-section");
        var nextSection = currentSection.nextAll(".shopify-section").first();
        if (nextSection.length) {
            $("html, body").animate({ scrollTop: nextSection.offset().top }, 800);
        }
    });
    function initSlick() {
        if ($(window).width() <= 767) {
            if (!$(".MobileSlider .rewards-program-list").hasClass("slick-initialized")) {
                $(".MobileSlider .rewards-program-list").slick({
                    dots: !1,
                    arrows: !1,
                    infinite: !0,
                    slidesToShow: 1,
                    centerMode: !0,
                    slidesToScroll: 1,
                });
            }
        } else {
            if ($(".MobileSlider .rewards-program-list").hasClass("slick-initialized")) {
                $(".MobileSlider .rewards-program-list").slick("unslick");
            }
        }
    }
    initSlick();
    $(window).on("resize", function () {
        initSlick();
    });
    function initSlick2() {
        if ($(window).width() <= 767) {
            if (!$(".MobileSlider .shop-brands-list").hasClass("slick-initialized")) {
                $(".MobileSlider .shop-brands-list").slick({
                    dots: !1,
                    arrows: !1,
                    infinite: !0,
                    slidesToShow: 2,
                    centerMode: !0,
                    slidesToScroll: 1,
                });
            }
        } else {
            if ($(".MobileSlider .shop-brands-list").hasClass("slick-initialized")) {
                $(".MobileSlider .shop-brands-list").slick("unslick");
            }
        }
    }
    initSlick2();
    $(window).on("resize", function () {
        initSlick2();
    });
    function initSlick3() {
        if ($(window).width() <= 767) {
            if (!$(".MobileSlider.shop-filters-list").hasClass("slick-initialized")) {
                $(".MobileSlider.shop-filters-list").slick({
                    dots: !1,
                    arrows: !1,
                    infinite: !0,
                    slidesToShow: 2,
                    centerMode: !0,
                    slidesToScroll: 1,
                });
            }
        } else {
            if ($(".MobileSlider.shop-filters-list").hasClass("slick-initialized")) {
                $(".MobileSlider.shop-filters-list").slick("unslick");
            }
        }
    }
    initSlick3();
    $(window).on("resize", function () {
        initSlick3();
    });
    function initSlick4() {
        if ($(window).width() <= 767) {
            if (!$(".MobileSlider.product-grid").hasClass("slick-initialized")) {
                $(".MobileSlider.product-grid").slick({
                    dots: !1,
                    arrows: !1,
                    infinite: !0,
                    slidesToShow: 1,
                    centerMode: !0,
                    slidesToScroll: 1,
                });
            }
        } else {
            if ($(".MobileSlider.product-grid").hasClass("slick-initialized")) {
                $(".MobileSlider.product-grid").slick("unslick");
            }
        }
    }
    initSlick4();
    $(window).on("resize", function () {
        initSlick4();
    });
});
